import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import {
  fetchAllMetadata,
  createMetadata,
  updateMetadata,
  deleteMetadata,
  toggleMetadataStatus,
  uploadOGImage,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import SEOList from "./SEOTable";
import SEOFormModal from "./SEOFormModal";
import DashboardLayout from "../DashboardLayout";

const SEOPages = () => {
  const [metadata, setMetadata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSeletedItem] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });

  const navigate = useNavigate();

  const fetchMetadata = async (page = 1) => {
    try {
      setLoading(true);
      const res = await fetchAllMetadata(page, 10);
      if (res?.data?.success) {
        setMetadata(res.data.data);
        setPagination(res.data.pagination);
      } else {
        handleErrors(res, navigate);
      }
    } catch (error) {
      console.error("Error fetching SEO metadata:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMetadata();
  }, []);

  const handleAdd = () => {
    setSeletedItem(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setSeletedItem(item);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this metadata?")) {
      try {
        const res = await deleteMetadata(id);
        if (res?.data?.success) {
          toast.success("Metadata deleted successfully");
          fetchMetadata(pagination.currentPage);
        } else {
          handleErrors(res, navigate);
        }
      } catch (error) {
        console.error("Error deleting metadata:", error);
      }
    }
  };

  const handleToggleStatus = async (data) => {
    try {
      const res = await toggleMetadataStatus(data);
      console.log("Res: ", res);
      if (res?.data?.success) {
        toast.success("Status updated successfully");
        fetchMetadata(pagination.currentPage);
      } else {
        handleErrors(res, navigate);
      }
    } catch (error) {
      console.error("Error toggling status:", error);
    }
  };

  const handleSubmit = async (values, file) => {
    try {
      setModalLoading(true);
      let res;
      if (selectedItem) {
        res = await updateMetadata(selectedItem.id, values);
      } else {
        res = await createMetadata(values);
      }

      if (res?.data?.success) {
        const metadataId = selectedItem ? selectedItem.id : res.data.data.id;

        if (file) {
          const formData = new FormData();
          formData.append("image", file);
          const uploadRes = await uploadOGImage(metadataId, formData);
          if (!uploadRes?.data?.success) {
            toast.error("OG Image upload failed");
          }
        }

        toast.success(
          selectedItem
            ? "Metadata updated successfully"
            : "Metadata created successfully",
        );
        setShowModal(false);
        fetchMetadata(selectedItem ? pagination.currentPage : 1);
      } else {
        handleErrors(res, navigate);
      }
    } catch (error) {
      console.error("Error submitting SEO metadata:", error);
    } finally {
      setModalLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="row pl-2">
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Management</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#d1cdcdbf" }}
                >
                  SEO Management
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container text-light bg-dark rounded mb-4 p-3"
        data-testid="seo-management"
      >
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 className="text-light mb-0">SEO & Page Metadata</h3>
            <p className="text-secondary small">
              Manage dynamic SEO tags for all platform pages.
            </p>
          </Col>
          <Col xs="auto">
            <Button variant="success" onClick={handleAdd}>
              {/* <FaPlus className="me-2" /> */}
              Add Metadata
            </Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <SEOList
              data={metadata}
              loading={loading}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggleStatus={handleToggleStatus}
              pagination={pagination}
              onPageChange={(page) => fetchMetadata(page)}
            />
          </Col>
        </Row>

        <SEOFormModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onSubmit={handleSubmit}
          initialValues={selectedItem}
          loading={modalLoading}
          isEdit={!!selectedItem}
        />
      </div>
    </DashboardLayout>
  );
};

export default SEOPages;
